import { call, put, takeLatest } from 'redux-saga/effects';
import { popularDestinationsService } from './service';
import { GET_POPULAR_DESTINATIONS, GET_POPULAR_DESTINATIONS_SUCCESS } from './types';

function* getPopularDestinations() {
  try {
    const res = yield call(popularDestinationsService.getPopularDestinations);
    yield put({
      type: GET_POPULAR_DESTINATIONS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    console.log(err);
  }
}

export const watchPopularDestinations = function* watchPopularDestination() {
  yield takeLatest(GET_POPULAR_DESTINATIONS, getPopularDestinations);
};
